import React, { useMemo } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { Button, ButtonGroup } from "@curves/ui-base";
import { isEqual } from "@util/utils";

/** =========================================================
 * 📌 批次扣款清單(如信用卡、ACH、現金) 切換器
 *  =========================================================
 */
const DebitListSwitcher = ({ sourceData, currentPaymentMethod, ...rest }) => {
	const { debitListComponent: DebitListComponent, listData } = sourceData[currentPaymentMethod];

	const actions = useMemo(() => {
			return Object.keys(sourceData).map((key) => {
				const { label, value, to, buttonComponent } = sourceData[key];
				return {
					label,
					value,
					to,
					component: buttonComponent || Link
				};
			});
		},
		// eslint-disable-next-line
		[]);

	return (
		<>
			<ButtonGroup className={"report-btn-group mb-2"}>
				{actions.map(({ label, value, ...rest }) => (
					<Button key={value} className={clsx({ current: isEqual(currentPaymentMethod, value) })} {...rest}>
						{label}
					</Button>
				))}
			</ButtonGroup>
			{React.isValidElement(DebitListComponent) ? React.cloneElement(DebitListComponent, { list: listData }) : null}
		</>
	);
};


export default DebitListSwitcher;